<template>
  <div class="kontaktBearbeiten">
    <div v-if="kontakteStatus.updatingContact" class="text-center">
      <b-spinner variant="warning" type="grow"></b-spinner>
    </div>
    <div v-else>
      <b-alert
        v-if="!persoenlichesValidation"
        variant="danger"
        show
      >Es wurden nicht alle Pflichtfelder ausgefüllt. Bitte gib Vorname, Name, Email und Mobilnummer an.</b-alert>
      <b-tabs content-class="mt-3">
        <b-tab title="Persönliches" active>
          <b-form @submit.prevent="kontaktBearbeiten">
            <b-form-row>
              <b-col cols="12" sm="6">
                <b-form-group id="geschlecht-group" label="Anrede" label-for="geschlecht">
                  <b-form-select
                    id="geschlecht"
                    v-model="kontakt.geschlecht"
                    :state="geschlechtState"
                  >
                    <option value="m">Herr</option>
                    <option value="w">Frau</option>
                    <option value="d">Sonstige</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col cols="12" sm="6">
                <b-form-group id="vorname-group" label="Vorname *" label-for="vorname">
                  <b-form-input
                    id="vorname"
                    v-model="kontakt.vorname"
                    type="text"
                    :state="vornameState"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6">
                <b-form-group id="name-group" label="Name *" label-for="name">
                  <b-form-input
                    id="name"
                    v-model="kontakt.name"
                    type="text"
                    :state="nameState"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col cols="12" sm="6">
                <b-form-group id="email-group" label="E-Mail Adresse" label-for="email">
                  <b-form-input
                    id="email"
                    v-model="kontakt.email"
                    type="email"
                    :state="emailState"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6">
                <b-form-group id="mobil-group" label="Mobilnummer" label-for="mobil">
                  <b-form-input id="mobil" v-model="kontakt.mobil" type="text" :state="mobilState"></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="favorit"
                    v-model="kontakt.favorit"
                    name="favorit"
                    value=1
                    unchecked-value=0
                  >Zu Favoriten hinzufügen</b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-button
              @click="$bvModal.hide(`kontaktBearbeiten-${kontakt.id}`)"
              variant="secondary"
              class="mr-3"
            >Abbrechen</b-button>
            <b-button
              type="submit"
              variant="warning"
              class="float-right"
              v-bind:disabled="!persoenlichesValidation"
            >Speichern</b-button>
          </b-form>
        </b-tab>

        <b-tab title="Anschrift">
          <b-form @submit.prevent="kontaktBearbeiten">
            <b-form-group id="strasse-group" label="Straße" label-for="strasse">
              <b-form-input
                id="strasse"
                v-model="kontakt.strasse"
                type="text"
                :state="strasseState"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="plz-group" label="PLZ" label-for="plz">
              <b-form-input id="plz" v-model="kontakt.plz" type="text" :state="plzState"></b-form-input>
            </b-form-group>

            <b-form-group id="ort-group" label="Ort" label-for="ort">
              <b-form-input id="ort" v-model="kontakt.ort" type="text" :state="ortState"></b-form-input>
            </b-form-group>

            <b-form-group id="land-group" label="Land" label-for="land">
              <b-form-input id="land" v-model="kontakt.land" type="text" :state="landState"></b-form-input>
            </b-form-group>

            <b-button
              @click="$bvModal.hide(`kontaktBearbeiten-${kontakt.id}`)"
              variant="secondary"
              class="mr-3"
            >Abbrechen</b-button>
            <b-button
              type="submit"
              variant="warning"
              class="float-right"
              v-bind:disabled="!persoenlichesValidation"
            >Speichern</b-button>
          </b-form>
        </b-tab>

        <b-tab title="Kontaktinformationen">
          <b-form @submit.prevent="kontaktBearbeiten">
            <b-form-row>
              <b-col>
                <b-form-group id="tel-group" label="Telefonnummer" label-for="tel">
                  <b-form-input id="tel" v-model="kontakt.tel" type="text" :state="telState"></b-form-input>
                </b-form-group>

                <b-form-group id="fax-group" label="Fax" label-for="fax">
                  <b-form-input id="fax" v-model="kontakt.fax" type="text" :state="faxState"></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group id="telG-group" label="Telefonnummer Geschäftlich" label-for="telG">
                  <b-form-input id="telG" v-model="kontakt.telG" type="text" :state="telGState"></b-form-input>
                </b-form-group>

                <b-form-group id="faxG-group" label="Fax Geschäftlich" label-for="faxG">
                  <b-form-input id="faxG" v-model="kontakt.faxG" type="text" :state="faxGState"></b-form-input>
                </b-form-group>

                <b-form-group id="mobilG-group" label="Mobilnummer Geschäftlich" label-for="mobilG">
                  <b-form-input
                    id="mobilG"
                    v-model="kontakt.mobilG"
                    type="text"
                    :state="mobilGState"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  id="emailG-group"
                  label="E-Mail Adresse Geschäftlich"
                  label-for="emailG"
                >
                  <b-form-input
                    id="emailG"
                    v-model="kontakt.emailG"
                    type="email"
                    :state="emailGState"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-button
              @click="$bvModal.hide(`kontaktBearbeiten-${kontakt.id}`)"
              variant="secondary"
              class="mr-3"
            >Abbrechen</b-button>
            <b-button
              type="submit"
              variant="warning"
              class="float-right"
              v-bind:disabled="!persoenlichesValidation"
            >Speichern</b-button>
          </b-form>
        </b-tab>

        <b-tab title="Bild">
          <KontaktBildBearbeiten :kontakt="kontakt" @createImageUpdateToast="emitImageUpdateToast" />
        </b-tab>

        <b-tab title="Kontakt löschen">
          <b-button
            variant="danger"
            @click="kontaktLoeschen"
            class="m-1"
          >Kontakt unwiderruflich Löschen</b-button>
        </b-tab>
      </b-tabs>

      <hr />

      <p class="text-left small">mit * gekennzeichnete Felder sind Pflichtfelder</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import KontaktBildBearbeiten from "./KontaktBildBearbeiten";

export default {
  name: "kontaktBearbeiten",
  components: {
    KontaktBildBearbeiten
  },
  props: ["kontakt"],
  computed: {
    ...mapGetters(["kontakteStatus"]),
    geschlechtState() {
      if (this.kontakt.geschlecht === null) {
        return null;
      } else if (
        this.kontakt.geschlecht.toLowerCase() === "m" ||
        this.kontakt.geschlecht.toLowerCase() === "w" ||
        this.kontakt.geschlecht.toLowerCase() === "d"
      ) {
        return true;
      } else {
        return false;
      }
    },
    vornameState() {
      if (this.kontakt.vorname === "") return null;

      return this.kontakt.vorname.length > 2 ? true : false;
    },
    nameState() {
      if (this.kontakt.name === "") return null;

      return this.kontakt.name.length > 2 ? true : false;
    },
    strasseState() {
      if (this.kontakt.strasse === null || this.kontakt.strasse === "")
        return null;

      return this.kontakt.strasse.length > 2 ? true : false;
    },
    plzState() {
      if (this.kontakt.plz === null || this.kontakt.plz === "") return null;

      return this.kontakt.plz.length > 2 ? true : false;
    },
    ortState() {
      if (this.kontakt.ort === null || this.kontakt.ort === "") return null;

      return this.kontakt.ort.length > 2 ? true : false;
    },
    landState() {
      if (this.kontakt.land === null || this.kontakt.land === "") return null;

      return this.kontakt.land.length > 0 ? true : false;
    },
    telState() {
      if (this.kontakt.tel === null || this.kontakt.tel === "") return null;

      return this.kontakt.tel.length > 2 ? true : false;
    },
    faxState() {
      if (this.kontakt.fax === null || this.kontakt.fax === "") return null;

      return this.kontakt.fax.length > 2 ? true : false;
    },
    mobilState() {
      if (this.kontakt.mobil === null || this.kontakt.mobil === "") return null;

      return this.kontakt.mobil.length > 2 ? true : false;
    },
    emailState() {
      if (this.kontakt.email === "") return null;

      return this.emailRegex.test(this.kontakt.email) ? true : false;
    },
    telGState() {
      if (this.kontakt.telG === null || this.kontakt.telG === "") return null;

      return this.kontakt.telG.length > 2 ? true : false;
    },
    faxGState() {
      if (this.kontakt.faxG === null || this.kontakt.faxG === "") return null;

      return this.kontakt.faxG.length > 2 ? true : false;
    },
    mobilGState() {
      if (this.kontakt.mobilG === null || this.kontakt.mobil === "")
        return null;

      return this.kontakt.mobil.length > 2 ? true : false;
    },
    emailGState() {
      if (this.kontakt.emailG === null || this.kontakt.emailG === "")
        return null;

      return this.emailRegex.test(this.kontakt.emailG) ? true : false;
    },
    persoenlichesValidation() {
      return this.vornameState && this.nameState ? true : false
    },
    kontaktinformationValidation() {
      return (this.emailState && this.mobilState) ? true : false
    }
  },
  methods: {
    ...mapActions(["updateKontakt", "deleteKontakt"]),
    kontaktBearbeiten () {
      this.updateKontakt(this.kontakt).then(() => {
        const toastData = {
          title: "",
          msg: "Die Änderungen wurden gespeichert.",
          variant: "success"
        };

        if (this.kontakteStatus.errMsg) {
          toastData.title = "Es ist etwas schief gelaufen.";
          toastData.msg = this.kontakteStatus.errMsg;
          toastData.variant = "danger";
        }

        this.$emit("createUpdateToast", toastData);

        if (!this.kontakteStatus.errMsg) {
          this.$bvModal.hide(`kontaktBearbeiten-${this.kontakt.id}`);
        }
      });
    },
    kontaktLoeschen() {
      if (confirm("Soll der Kontakt wirklich gelöscht werden?")) {
        this.deleteKontakt(this.kontakt.id)
          .then(() => {
            const toastData = {
              title: "",
              msg: "Der Kontakt wurde gelöscht.",
              variant: "success"
            };

            if (this.kontakteStatus.errMsg) {
              toastData.title = "Es ist etwas schief gelaufen.";
              toastData.msg = this.kontakteStatus.errMsg;
              toastData.variant = "danger";
            }

            this.$emit("createUpdateToast", toastData);

            if (!this.kontakteStatus.errMsg) {
              this.$bvModal.hide(`kontaktBearbeiten-${this.kontakt.id}`);
            }
          });
      }
    },
    emitImageUpdateToast (toastData) {
      this.$emit("createUpdateToast", toastData)
    }
  },
  data() {
    return {
      emailRegex: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
    };
  }
};
</script>
